import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericRepository } from "../../generic-repository/GenericRepository";
import { ResponseModel } from "../../../models/SharedModels/response.model";
import { IOnBoardingRepository } from "./IOnboardingRepository";
import { environment } from "../../../../environments/environment";
import { Employee } from "../../../models/HR/Employee/employee";

@Injectable({
  providedIn: 'root'
})
export class OnboardingRepository
  extends GenericRepository<Employee>
  implements IOnBoardingRepository {

  constructor(protected _http: HttpClient) {
    super(_http, 'api/OnBoarding', environment.urlAddress);
  }

  SaveRec(item: Employee): Observable<ResponseModel> {
    return this.PostData('/SaveRec', item)
      .pipe(map(this.extractData), catchError(this.handleError));
  }
}